export const INTAKE_QUERY_KEYS = {
  receipts: ['goods-intake', 'receipts'] as const,
  receipt: (id: string) => ['goods-intake', 'receipt', id] as const,
};
